import { Injectable } from '@angular/core';
import {MenuItem} from "primeng/api";

@Injectable({
  providedIn: 'root'
})
export abstract class MasterMenuItemsService {
  abstract getMenuItems(translations: any, isLoggedIn: boolean): MenuItem[];

}
